import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AppLogger } from '@/lib/logger';

const log = AppLogger.getLogger(import.meta);
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AddManufacturerComposer } from "@/forms/sensory";
import { Plus } from "lucide-react";

interface AddManufacturerButtonProps {
  onSuccess?: () => void;
}

export function AddManufacturerButton({ onSuccess }: AddManufacturerButtonProps) {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const handleError = (error: Error) => {
    log.error("Failed to create manufacturer:", error);
    alert(`Failed to create manufacturer: ${error.message}`);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="gap-2">
          <Plus className="h-4 w-4" />
          Add Manufacturer
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add New Manufacturer</DialogTitle>
        </DialogHeader>
        <AddManufacturerComposer
          onSuccess={handleSuccess}
          onError={handleError}
          onCancel={() => setOpen(false)}
          showHeader={false}
        />
      </DialogContent>
    </Dialog>
  );
}
